"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importDefault(require("react"));
function submitForm(event, submitHandler) {
    event.preventDefault();
    if (submitHandler) {
        submitHandler();
    }
}
var Form = function (_a) {
    var children = _a.children, onSubmit = _a.onSubmit;
    return (react_1.default.createElement("form", { className: "flex flex-col", onSubmit: function (e) { return submitForm(e, onSubmit); } }, children));
};
exports.Form = Form;
